module.exports = __webpack_public_path__ + "img/07.2c053c83.png";